export default __webpack_public_path__ + "static/media/nobuy.88ab9ff5.png";